export default "__VITE_ASSET__63f9a032__"